<template>
  <div class="py-l bg-blackly text-white">
    <div class="container h-full" data-test-id="header">
      <h2 v-if="heading" class="block fluid-3xl leading-tightest mb-10 md:mb-20 text-center" v-html="heading"></h2>
      <div v-if="tiles.length" class="flex flex-col md:flex-row justify-between h-full">
        <div v-for="tile in tiles" :key="tile.id" class="my-5 sm:my-10 md:mx-5 md:my-0" data-test-id="tile">
          <h3 class="fluid-3xl leading-tightest text-center text-br-green-light">{{ tile.numericValue }}</h3>
          <p class="fluid-base leading-relaxed font-light text-center">{{ tile.body }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'NumbersOnBlackBackground',
  props: {
    tiles: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      default: null,
    },
  },
});
</script>
